module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "TITLE"
  }, [_vm._v("A Theology"), _c('br'), _vm._v("of Grace"), _c('br'), _vm._v("in Six Controversies")]), _vm._v(" "), _c('p', {
    staticClass: "AUTHOR"
  }, [_vm._v("Edward T. Oakes, S.J.")]), _vm._v(" "), _c('p', {
    staticClass: "COMPANY"
  }, [_vm._v("William B. Eerdmans Publishing Company"), _c('br'), _vm._v("Grand Rapids, Michigan")]), _vm._v(" "), _c('p', {
    staticClass: "IMPRIMATUR-FIRST"
  }, [_vm._v("© 2016 Jesuits USA Central & Southern Province"), _c('br'), _vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "IMPRIMATUR"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Imprimi potest:")]), _vm._v("\tV. Rev. Douglas Marcouiller, S.J."), _c('br'), _vm._v("\tProvincial, Missouri Province of the Society of Jesus"), _c('br'), _vm._v("\tSeptember 1, 2013")]), _vm._v(" "), _c('p', {
    staticClass: "IMPRIMATUR"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nihil obstat:")]), _vm._v("\tRev. Thomas G. Weinandy, O.F.M., Cap."), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Censor deputatus"), _c('br')]), _vm._v("\tCapuchin College, Washington, D.C."), _c('br'), _vm._v("\tAugust 29, 2013")]), _vm._v(" "), _c('p', {
    staticClass: "IMPRIMATUR"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Imprimatur:")]), _vm._v("\tFrancis Cardinal George, O.M.I., Ph.D., S.T.D"), _c('br'), _vm._v("\tArchbishop of Chicago"), _c('br'), _vm._v("\tSeptember 4, 2012")]), _vm._v(" "), _c('p', {
    staticClass: "IMPRIMATUR"
  }, [_vm._v("In accordance with Canon 824, permission to publish was granted by His Eminence, Francis Cardinal George, O.M.I., Archbishop of Chicago. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nihil obstat")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Imprimatur")]), _vm._v(" are official declarations that the book is free from doctrinal and moral error. No implication is contained therein that those who have granted the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nihil obstat")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Imprimatur")]), _vm._v(" agree with the content, opinions, or statements expressed. No legal responsibility is assumed by the grant of this permission.")]), _vm._v(" "), _c('p', {
    staticClass: "IMPRIMATUR"
  }, [_vm._v("Published 2016 by"), _c('br'), _vm._v("Wm. B. Eerdmans Publishing Co."), _c('br'), _vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505")]), _vm._v(" "), _c('p', {
    staticClass: "IMPRIMATUR"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "LIBRARY"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Names: Oakes, Edward T., author.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Title: A theology of grace in six controversies / Edward T. Oakes, S.J.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Description: Grand Rapids, Michigan: Eerdmans Publishing Company, 2016. | "), _c('br'), _vm._v("Series: Interventions")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Identifiers: LCCN 2015045476 | ISBN 9780802873200 (pbk: alk. paper)"), _c('br'), _vm._v("eISBN 9781467445368 (ePub)"), _c('br'), _vm._v("eISBN 9781467444897 (Kindle)")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Subjects: LCSH: Grace (Theology) | Salvation—Christianity. | Catholic Church—Doctrines.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Classification: LCC BT761.3 .O225 2016 | DDC 234—dc23"), _c('br'), _vm._v("LC record available at http://lccn.loc.gov/2015045476")]), _vm._v(" "), _c('p', {
    staticClass: "URL"
  }, [_c('a', {
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98551404","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Oakes_A_Theology_of_Grace2.vue
// module id = 63
// module chunks = 0